import "./App.css";
import Header from "./component/header/header";
import Hero from "./component/hero/hero";

function App() {
  return (
    <div>
      <Header></Header>
      <Hero></Hero>
    </div>
  );
}

export default App;
